interface PillColorStyle {
  DANGER: string;
  INFO: string;
  SUCCESS: string;
}

export let PILL_COLOR_STYLE: PillColorStyle = {
  DANGER: 'pill--danger',
  INFO: 'pill--info',
  SUCCESS: 'pill--sucess'
};
